import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SubscriptionStore } from '../stores/subscription.store';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';

/**
 * Blocks navigation to any route guarded by this when the BU's subscription is
 * Expired. SuperAdmins and routes already under /billing or /account/profile
 * are exempt. On block, redirects to /billing and toasts a short notice.
 */
export const subscriptionReadOnlyGuard: CanActivateFn = (_route, state) => {
  const store  = inject(SubscriptionStore);
  const auth   = inject(AuthService);
  const router = inject(Router);
  const toast  = inject(ToastService);

  // SuperAdmin bypasses BU-level subscription gating entirely.
  if (auth.isSuperAdmin()) return true;

  if (!store.isExpired()) return true;

  // Always allow the read-only surfaces.
  const url = state.url || '';
  if (url.startsWith('/billing') || url.startsWith('/account/profile')) return true;

  toast.warning('Subscription expired', 'Read-only mode — renew to restore access.');
  router.navigate(['/billing']);
  return false;
};
